<template>
  <survey-calculator
    title="label_violenceSurvey_calculator_title"
    background-color="#f5fafd"
    template-id="ViolenceSurvey"
  />
</template>
<script>
import SurveyCalculator from "./SurveyCalculator";
import { mapGetters } from "vuex";
export default {
  name: "ViolenceSurveyCalculator",
  components: { SurveyCalculator },
  computed: {
    ...mapGetters(["getCurrentSnapshot"]),
  },
  watch: {
    getCurrentSnapshot: {
      deep: true,
      handler() {
        this.checkAccess();
      },
    },
  },
  created() {
    this.checkAccess();
  },
  methods: {
    checkAccess() {
      if (!this.getCurrentSnapshot.surveyViolenceStatus) {
        this.$router.push("/home");
      }
    },
  },
};
</script>
